<div class="highcharts-tooltip">
  <span
    *ngIf="overallData[metricId] && overallData[metricId]['overall'] != null"
  >
    <div>
      <span class="metric-tooltip title comp_title capitalize tile_body">{{
        column.title
      }}</span>
      <span
        class="metric-tooltip value comp_value tooltip_value"
        [ngStyle]="{
          color: overallDataColors
            ? overallDataColors[metricId]
            : overallData[metricId].color
        }"
      >
        {{ overallData[metricId]["overallPrefix"]
        }}{{ overallData[metricId]["overall"] | number
        }}{{ overallData[metricId]["overallSuffix"] }}
      </span>
    </div>
    <div>
      <span class="metric-tooltip subtitle">{{
        overallData[metricId].overallSubtitle
      }}</span>
      <span
        class="metric-tooltip subtitle district-goal"
        *ngIf="overallData[metricId].goal"
      >
        <span *ngIf="studentTooltip"
          >School goal: {{ overallData[metricId].goal }}</span
        >
        <span *ngIf="!studentTooltip"
          >District goal: {{ overallData[metricId].goal }}</span
        >
      </span>
    </div>
    <div
      class="metric-tooltip comp_description body_tooltip_text"
      *ngIf="overallData[metricId].overallSuffix"
    >
      <strong>{{ overallData[metricId].numerator | number }}</strong> of
      <strong>{{ overallData[metricId].denominator | number }}</strong>
      {{ overallData[metricId].descriptor }}
    </div>
    <div
      class="metric-tooltip comp_description body_tooltip_text"
      *ngIf="!overallData[metricId].overallSuffix"
    >
      <strong>{{ overallData[metricId].numerator | number }}</strong>
      {{ overallData[metricId].descriptor }}
    </div>
  </span>
  <span
    *ngIf="
      !overallData[metricId] ||
      (overallData[metricId] && overallData[metricId]['overall'] == null)
    "
  >
    <span class="metric-tooltip title comp_title capitalize tile_body"
      >No data available</span
    >
    <div class="metric-tooltip comp_description body_tooltip_text">
      We couldn't find any data for this metric.
    </div>
  </span>
</div>
